import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Button } from '@zebra-fed/zds-react-desktop';
import '@zebra-fed/icons/General/index.css';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import InputBase from '@material-ui/core/InputBase';
import { KeyboardDatePicker, MuiPickersUtilsProvider, } from '@material-ui/pickers';
import AlertModal from "../../../../components/modals/AlertModal";
import {
    buttonStatus,
    exportCSVDataToGCSBucketEventDetail,
    getURLFromGCSBucket,
    uploadExportedDataToGCSBucket
} from "../../../commonUtils/commonDashboardUtils";
import config from "../../../../data/application.properties";
import { AuthContext } from "../../../../authentication/Auth";
import app from "../../../../authentication/firebaseStart";

// let locations = [];
const ToolbarWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 18px;
`

const imgStyleLoader = {
    width: 18,
    height: 18,
    marginTop: 6,
    marginLeft: -15,
    marginRight: 5,
}

const TitleText = styled.h1`
    font-size: 20px;
    display: flex;`

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: '10px',
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: "#FFFFFF",
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}));

export default function Toolbar(props) {
    const { category, subCategory, deviceStateUpdatedBy, history, totalCount } = props;
    //console.log("category, subCategory, deviceStateUpdatedBy",category, subCategory, deviceStateUpdatedBy)
    const [searchVal, setSearchVal] = useState('');
    const [fromdateVal, setFromDateVal] = useState('');
    const [todateVal, setToDateVal] = useState('');
    const [sitenameVal, setSiteNameVal] = useState('');

    const [isError, setIsError] = useState(false)
    const [selectedDate, setSelectedDate] = React.useState(new Date());

    const alertModalRef = useRef();
    const [showState, setShowState] = useState('initial');
    const [exportResult, setExportResult] = useState('');
    const [uploadResult, setUploadResult] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const showStates = buttonStatus;
    const context = useContext(AuthContext);

    const [buttonProps, setButtonProps] = useState({
        isLoading: false,
        style: 'normal',
        title: 'Export',
        type: 'initial',
        color: '#007ABA',
        downloadFileName: "",
        files_path: ""
    });

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const getToken = async () => {
        return (await app.auth().currentUser.getIdTokenResult()).token;
    }
    let token = null;

    useEffect(() => {
        setSearchVal(props.searchText);
        setFromDateVal(props.fromDate);
        setToDateVal(props.toDate);
        setSiteNameVal(props.siteName);
        token = getToken();
    }, [])

    // useEffect(() => {
    //     if (showStates.state2 && exportResult !== '') {
    //         if (exportResult[0] === true) {
    //             setButtonProps({
    //                 ...buttonProps,
    //                 isLoading: false,
    //                 type: showStates.state3,
    //                 files_path: exportResult[1].data,
    //                 downloadFileName: ""
    //             })
    //             setShowState(showStates.state3)
    //             console.log("Triggering state 3")
    //         } else {
    //             setButtonProps({
    //                 isLoading: false,
    //                 style: 'normal',
    //                 title: 'Export Data',
    //                 type: 'initial',
    //                 color: '#007ABA',
    //                 files_path: "",
    //                 downloadFileName: ""
    //             })
    //             console.log("[Failure]Triggering Final Stage: ", buttonProps);
    //             setErrorMessage('File exporting to GCS bucket is failed.\nPlease Try again')
    //             alertModalRef.current.toggleDialog();
    //         }
    //     }
    // }, [exportResult])

    useEffect(() => {
        if (showStates.state2 && uploadResult !== '') {
            if (uploadResult[0] === true) {
                setButtonProps({
                    ...buttonProps,
                    isLoading: false,
                    style: 'ready_to_download',
                    title: 'Ready to Download',
                    type: showStates.state3,
                    color: '#FFC107',
                    downloadFileName: uploadResult[1].data
                })
                setShowState(showStates.state3)
                console.log("Triggering state 3")
                // setShowState(showStates.state4)
                // console.log("Triggering state 4")
            } else {
                setButtonProps({
                    isLoading: false,
                    style: 'normal',
                    title: 'Export Data',
                    type: 'initial',
                    color: '#007ABA',
                    downloadFileName: "",
                    files_path: ""
                })
                console.log("[Failure]Triggering Final Stage: ", buttonProps);
                setErrorMessage('Exported File uploading to GCS bucket, is failed. Please try again\n Error: ' + uploadResult[1].msg)
                alertModalRef.current.toggleDialog();
            }
        }
    }, [uploadResult])


    useEffect(() => {
        console.log("Show State :", buttonProps.type)
        if (showState === showStates.state2) {
            if (fromdateVal !== null || fromdateVal !== "") {
                console.log("Start Date: ", fromdateVal);
                setErrorMessage('Please select the start date')
            } else if (todateVal !== null || todateVal !== "") {
                console.log("End Date: ", todateVal);
                setErrorMessage('Please select the End date')
            } else if (sitenameVal !== null || sitenameVal !== "") {
                console.log("End Date: ", todateVal);
                setErrorMessage('Please select the Site Name')
            }
            let siteName = sitenameVal ? sitenameVal : "all"
            console.log("Site Name:" + siteName);
            async function exportCSVFiles() {
                let endPoint = config.EXPORT_ANALYTIC_EVENT_SUMMARY_DETAIL
                let result = await exportCSVDataToGCSBucketEventDetail(fromdateVal, todateVal, endPoint, siteName, token, category, subCategory, deviceStateUpdatedBy)
                //setExportResult(result)
                setUploadResult(result)
            }

            exportCSVFiles()
        }
        // if (showState === showStates.state3) {
        //     setButtonProps({
        //         ...buttonProps,
        //         isLoading: true,
        //     })

        //     async function uploadZipFiles() {
        //         let endPoint = config.EXPORT_ANALYTIC_EVENT_SUMMARY_DETAIL_ZIP_FILE
        //         let result = await uploadExportedDataToGCSBucket(buttonProps.files_path, endPoint, token)
        //         setUploadResult(result)
        //     }

        //     uploadZipFiles()
        // }
        if (showState === showStates.state3) {
            if (buttonProps.downloadFileName !== null
                && buttonProps.downloadFileName !== '') {
                setButtonProps({
                    ...buttonProps,
                    isLoading: false,
                    style: 'ready_to_download',
                    title: 'Ready to Download',
                    type: showStates.state4,
                    color: '#FFC107',
                });
                setTimeout(() => {
                    downloadDataFromGCSBucket(buttonProps.downloadFileName);
                }, 1000)
            }
        }

    }, [showState])

    /*
     * onButtonClick function that trigger when download data button clicked
     */
    const onButtonClick = () => {
        setButtonProps({
            isLoading: true,
            style: 'primary',
            title: 'Exporting...',
            type: showStates.state2,
            color: '#007ABA',
            files_path: "",
            downloadFileName: ""
        })
        setShowState(showStates.state2)
        console.log("Triggering state 2");
    }

    /**
     * downloadDataFromGCSBucket
     * @param fileName
     * @returns {Promise<void>}
     */
    const downloadDataFromGCSBucket = (fileName) => {
        console.log('Inside downloadData')
        setButtonProps({
            ...buttonProps,
            isLoading: true,
            style: 'normal',
            title: 'Downloading...',
            type: showStates.state5,
            color: '#FFC107',
            downloadFileName: fileName
        })

        async function getURL() {
            let result = await getURLFromGCSBucket(fileName);
            if (result[0]) {
                setErrorMessage(result[1])
                alertModalRef.current.toggleDialog();
            }
            postExecution()
        }

        getURL();
    }

    /**
     * postExecution
     */
    const postExecution = () => {
        setButtonProps({
            isLoading: false,
            style: 'normal',
            title: 'Export Data',
            type: 'initial',
            color: '#007ABA',
            downloadFileName: "",
            files_path: ""
        })
    }

    return (
        <>
            <AlertModal modalRef={alertModalRef} message={errorMessage} />
            <ToolbarWrapper>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container direction="row" wrap="nowrap" spacing={2}>
                        <Grid item xs={8}>
                            <div style={{
                                textAlign: "left",
                                paddingLeft: 10,
                                paddingTop: 4,
                                paddingRight: 10,
                                paddingBottom: 4,
                                marginTop: 24,
                                fontFamily: "Segoe UI",
                                
                            }}>
                                {
                                    history?.location?.state?.deviceStateUpdatedBy === 0 ||
                                        history?.location?.state?.deviceStateUpdatedBy === 1
                                        ?
                                        <div><span>{history?.location?.state?.deviceStateUpdatedBy === 0 ? "Manual" : "Automatic"}</span> <br /><p style={{margin:0,fontWeight:"bold"}}>{totalCount} set {history?.location?.state?.deviceStateUpdatedBy === 0 ? "manually" : "automatically"}</p></div>
                                        :
                                        <div><span>{history?.location?.state?.category}</span> </div>
                                }

                            </div>

                        </Grid>
                        <Grid item xs={4}>
                            <Button
                                fullWidth
                                type='primary'
                                id="download-data"
                                style={{
                                    float: "right",
                                    textAlign: "center",
                                    backgroundColor: buttonProps.color,
                                    height: 41,
                                    paddingLeft: 10,
                                    paddingTop: 4,
                                    paddingRight: 10,
                                    paddingBottom: 4,
                                    marginTop: 24,
                                    borderRadius: 4,
                                    fontFamily: "Segoe UI",
                                    border: '1px solid #ced4da',
                                    position: 'inline',
                                }}
                                dense={true}
                                onClick={() => {
                                    buttonProps.type === showStates.state3 ?
                                        downloadDataFromGCSBucket(buttonProps.downloadFileName) : onButtonClick()
                                }}
                            >
                                {buttonProps.isLoading ?
                                    <img src={process.env.PUBLIC_URL + '/csv_export.gif'} style={imgStyleLoader} /> : ""}
                                {buttonProps.title}
                            </Button>
                        </Grid>
                    </Grid>
                </MuiPickersUtilsProvider>
            </ToolbarWrapper>
        </>
    )
}
